import { DocUploadSubmitFromBrowser } from '../features/documentUpload';

export enum ApiStatus {
    Idle,
    Pending,
    Fulfilled,
    Rejected,
}

export interface DropDownOptions<T> {
    key?: string;
    label?: string;
    value: T;
    aemkey?: string;
}

export interface RadioOption {
    label: string;
    labelSecondary?: string;
    value: string;
}

export interface BladeBaseProps {
    isFocusedBlade?: boolean;
    isMainHeading?: boolean;
    disableReset?: boolean;
    enableBrowserUpload?: boolean;
    uploadedDocsRef?: React.MutableRefObject<DocUploadSubmitFromBrowser>;
}

export interface PersonalDetailsProps extends BladeBaseProps {
    layout?: Layout;
    useSingleEditButton?: boolean;
    showResidencySection?: boolean;
    showDriverLicenceSection?: boolean;
    useProfileLinkModal?: boolean;
}

export type Layout = 'grid' | 'block';

export type FrequencyType = 'Weekly'|'Fortnightly'|'Monthly';

export type BladeActionButtonT = HTMLButtonElement & HTMLAnchorElement;

export type AddElementFunction = (el: HTMLElement) => void;
